import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import constants from "../constants";
import Helper from "utils/helper";

// const chatBotDisabledForPages = [
//   "/staff/help",
//   "/owner/help",

//   "/staff/faq",
//   "/owner/faq",

//   constants.routes.privacyPolicy,
//   constants.routes.termsAndConditions,

//   "/patient/faq",
//   "/patient/help",

//   constants.routes.privacyPolicyPatient,
//   constants.routes.termsAndConditionsPatient,
//   constants.routes.aboutMiraxis,
// ];

const isHubspotAllowedEnv = () =>
  process.env.REACT_APP_CURRENT_ENV === "production" ||
  process.env.REACT_APP_CURRENT_ENV === "staging";

// const isHubspotAllowedForEnvAndPage = (pathname) =>
//   isHubspotAllowedEnv() && !chatBotDisabledForPages.includes(pathname);

const HUBSPOT_CONTAINER_ID = "hubspot-messages-iframe-container";
const HUBSPOT_SCRIPT_ID = "hs-script-loader";
const BODY_HIDE_CLASS = "hubspot-widget-hidden";

const removeHubspot = () => {
  document.body.classList.remove(BODY_HIDE_CLASS);
  const script = document.getElementById(HUBSPOT_SCRIPT_ID);
  if (script) script.remove();
  const widgetContainer = document.getElementById(HUBSPOT_CONTAINER_ID);
  if (widgetContainer) widgetContainer.remove();
  window._hsq = [];
};

const setHubspotWidgetVisible = (visible) => {
  if (visible) {
    document.body.classList.remove(BODY_HIDE_CLASS);
    const el = document.getElementById(HUBSPOT_CONTAINER_ID);
    if (el) el.style.display = "";
  } else {
    document.body.classList.add(BODY_HIDE_CLASS);
    const el = document.getElementById(HUBSPOT_CONTAINER_ID);
    if (el) el.style.display = "none";
  }
};

const ensureHideStyle = () => {
  if (document.getElementById("hubspot-hide-style")) return;
  const style = document.createElement("style");
  style.id = "hubspot-hide-style";
  style.textContent = `body.${BODY_HIDE_CLASS} #${HUBSPOT_CONTAINER_ID}{display:none!important}`;
  document.head.appendChild(style);
};

const useHubspot = () => {
  const profile = useSelector((data) => data.userProfile.profile);
  const location = useLocation();

  useEffect(() => {
    ensureHideStyle();
    const isLoggedOut = !Helper.isLoggedIn() && !profile;
    // const isAllowedPage = isHubspotAllowedForEnvAndPage(location.pathname);

    if (!isHubspotAllowedEnv() || !isLoggedOut) {
      removeHubspot();
      return;
    }

    setHubspotWidgetVisible(true);

    if (!document.getElementById(HUBSPOT_SCRIPT_ID)) {
      const _hsq = (window._hsq = window._hsq || []);
      _hsq.push(["setPath", "/"]);
      _hsq.push(["trackPageView"]);
      const script = document.createElement("script");
      script.src = `//js-na1.hs-scripts.com/21329775.js?t=${Date.now()}`;
      script.id = HUBSPOT_SCRIPT_ID;
      script.defer = true;
      script.async = true;
      document.body.appendChild(script);
    } else {
      const _hsq = (window._hsq = window._hsq || []);
      const currentPath = `${location.pathname}${location.search}`;
      _hsq.push(["setPath", currentPath]);
      _hsq.push(["trackPageView"]);
    }
  }, [profile, location]);
};

export default useHubspot;
